/* eslint-disable @typescript-eslint/naming-convention */

export const invoicingManagerRole = 'ROLE_INVOICING_MANAGER';

export const accessControls = {
  ROLE_USER: {
    readOwn: ['member', 'roomBooking', 'serviceBooking'],
    read: ['course'],
    create: ['roomBooking', 'serviceBooking'],
    edit: ['roomBooking', 'serviceBooking'],
    remove: ['roomBooking', 'serviceBooking'],
  },
  ROLE_INSTRUCTOR: {
    parent: 'ROLE_USER',
    read: ['member', 'courseInstance', 'satisfaction'],
    create: 'courseInstance',
    edit: 'courseInstance',
    remove: 'courseInstance',
  },
  ROLE_COURSE_MANAGER: {
    parent: 'ROLE_INSTRUCTOR',
    create: 'course',
    edit: 'course',
    remove: 'course',
  },
  ROLE_BOOKING_MANAGER: {
    parent: 'ROLE_INSTRUCTOR',
    read: ['roomBooking', 'serviceBooking', 'building'],
  },
  ROLE_BUILDING_MANAGER: {
    parent: 'ROLE_BOOKING_MANAGER',
    read: ['room'],
    create: ['building', 'service', 'room'],
    edit: ['building', 'service', 'room'],
    remove: ['building', 'service', 'room'],
  },
  ROLE_SATISFACTION_MANAGER: {
    parent: 'ROLE_INSTRUCTOR',
    read: 'satisfaction',
    create: 'satisfaction',
    edit: 'satisfaction',
    remove: 'satisfaction',
  },
  ROLE_ADMIN: {
    parent: '*',
    read: '*',
    create: '*',
    edit: '*',
    remove: '*',
  },
};

accessControls[invoicingManagerRole] = {
  parent: 'ROLE_BOOKING_MANAGER',
    read: ['invoice', 'member'],
    create: 'invoice',
    edit: ['invoice', 'member'],
    remove: ['member'],
};
